import { lang } from '../../../../localization'

/**
 * The column widths for the Request Monitoring table.
 *
 * One definition, used by BOTH the header and the rows, because they must agree or the
 * labels stop sitting above their data. They were maintained separately and had drifted at
 * every breakpoint below 1800px — the header giving User IP 2.9fr against the row's 3.1fr,
 * and Request Method 1.9fr against 1.5fr, so those two columns ran into each other and an
 * operator reported "the columns are not displayed correctly".
 *
 * Above 1800px the two happened to match, which is why the table looks right on a wide
 * monitor and wrong on the screen the report came from.
 *
 * The row's values are the ones kept: the header carries short labels while the cells carry
 * a session-length user id and a URL, so the data is what decides whether a width works.
 */
export const monitoringGridColumns = {
  /** ≥ 1800px. */
  base: '4fr 5fr 3fr 4fr 6fr 6fr 2fr 1fr',

  /** 1360px–1800px. */
  medium:
    lang === 'en'
      ? '2.2fr 5.3fr 3.1fr 1.5fr 6.1fr 6.1fr 1.2fr 1.1fr'
      : '2.5fr 5.4fr 3.1fr 1.5fr 6.1fr 6.1fr 1.2fr 1.1fr',

  /** < 1360px. */
  small:
    lang === 'en'
      ? '2.2fr 5.3fr 3.1fr 1.5fr 6.1fr 6.1fr 1.2fr 1.1fr'
      : '2.5fr 5.2fr 3.1fr 1.5fr 6.1fr 6.1fr 1.2fr 1.1fr'
} as const

/** Every template has to name the same number of columns, or a cell lands under the wrong label. */
export const monitoringGridColumnCount = 8
